module.exports = __webpack_public_path__ + "static/media/ForwardRef.ba4d7cd3.md";